import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SocialYoutubeplayIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialYoutubeplay",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.59 14.07 7.89 2.36C7.53 2.14 7.09 2 6.62 2c-.4 0-.78.1-1.11.27h.01c-.7.41-1.16 1.16-1.16 2.02v23.39c0 .86.46 1.62 1.15 2.04h.01c.33.18.72.28 1.13.28h.08c.43 0 .83-.14 1.15-.38s18.7-11.65 18.7-11.65a2.32 2.32 0 0 0 1.06-1.95s0-.01 0-.01v-.06c0-.8-.42-1.5-1.05-1.89Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M31.33 8.5a4 4 0 0 0-2.83-2.83C26 5 16 5 16 5S5.99 5 3.5 5.67A4 4 0 0 0 .67 8.5C0 11 0 16.2 0 16.2s0 5.21.67 7.7a4 4 0 0 0 2.83 2.83c2.5.67 12.5.67 12.5.67s10.01 0 12.5-.67a4 4 0 0 0 2.83-2.83c.67-2.5.67-7.7.67-7.7s0-5.21-.67-7.7M12.8 21v-9.6l8.31 4.8z"
      })
    })
  }));
};
SocialYoutubeplayIcon.displayName = 'SocialYoutubeplayIcon';